import React from 'react'
import { PropertyPercentIncomeYearly } from '../../list/types'
import { Table, Tag } from 'antd'
import { ColumnsType } from 'antd/lib/table'

type Props = {
  data: PropertyPercentIncomeYearly[]
}

export const PropertyTablePage: React.FC<Props> = ({ data }) => {
  const columns: ColumnsType<PropertyPercentIncomeYearly> = [
    {
      title: 'Year',
      dataIndex: 'Year',
    },
    {
      title: 'Rental dividend plan',
      dataIndex: 'RentalDividendPlan',
    },
    {
      title: 'Rental dividend current',
      dataIndex: 'RentalDividendCurrent',
    },
    {
      title: 'Rental dividend fact',
      dataIndex: 'RentalDividendFact',
    },
    {
      title: 'Property appreciation plan',
      dataIndex: 'PropertyAppreciationPlan',
    },
    {
      title: 'Property appreciation current',
      dataIndex: 'PropertyAppreciationCurrent',
    },
    {
      title: 'Property appreciation fact',
      dataIndex: 'PropertyAppreciationFact',
    },
    {
      title: 'Status',
      dataIndex: 'IsCompleted',
      render: (item: boolean) => {
        if (item) {
          return <Tag color="green">Completed</Tag>
        } else {
          return <Tag color="red">Not completed</Tag>
        }
      },
    },
  ]

  return (
    <Table
      dataSource={data}
      bordered={true}
      rowKey="YearNumber"
      columns={columns}
      pagination={false}
    />
  )
}
